import React, { PureComponent } from 'react';
import Grid from '@mui/material/Grid';
import { Add as AddIcon } from '@mui/icons-material';
import Text from '../../components/Text.js';
import Button from '../../components/Button.js';
import MessageCard from '../../components/Cards/MessageCard.js';
import ContentBlock from '../../components/Divs/ContentBlock.js';
import StepCompletionNotif from '../../components/Modals/StepCompletionNotif.js';
import Modal from '../../components/Modals/Modal.js';
import FileDropZoneModal from '../../components/Modals/DropZoneModal.js';
import ClassAndDivisionDetailsModal from '../ClassesDivisions/ClassAndDivisionDetails.js';
import * as Theme from '../../theme/index.js';
import CensusTable from './CensusTable.js';
import { styled } from '@mui/material/styles';
import censusFormImage from '../../assets/census-form-example.png';
import censusFormImageStudent from '../../assets/census-form-example-student.png';
import csvIcon from '../../assets/csv.png';
import xlsIcon from '../../assets/xls.png';
import numbersIcon from '../../assets/numbers.png';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
import { EmployeeModalHandler } from '../../index.js';
import { maritalStatusOptions } from '../../services/selectFieldOptions.js';
const StyledLink = styled('a')(({
  theme
}) => ({
  textDecoration: 'none',
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'space-around',
  margin: '10px',
  padding: '10px',
  backgroundColor: Theme.colors.lightGrey,
  boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
  '&:hover': {
    boxShadow: '0px 1px 1px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px -1px rgba(0, 0, 0, 0.12)',
    filter: 'brightness(97%)'
  }
}));
class Census extends PureComponent {
  state = {
    showNewEmployee: false,
    currentEmployee: null,
    successDialogOpen: false,
    showDropZone: false,
    showExplanation: false,
    censusForm: false,
    largePhoto: false,
    showTemplateModal: false,
    failedRecords: null
  };
  _submitCensus = async () => {
    const success = await this.props.submitCensus(this.props.accountID);
    if (success) {
      this.setState({
        successDialogOpen: true,
        failedRecords: null
      });
    }
  };
  _submitFile = async files => {
    const form = new FormData();
    form.append('file', files[0]);
    const response = await this.props.uploadCensus(form, this.props.accountID);
    if (response.failedRecords) {
      this.setState({
        failedRecords: response.failedRecords
      });
    } else {
      this.setState({
        failedRecords: null
      });
    }
    return false;
  };
  _closeSuccessDialog = () => {
    this.setState({
      successDialogOpen: false
    });
  };
  _goToNextStep = () => {
    this.setState({
      successDialogOpen: false
    });
    this.props.setSelectedSection(null);
  };
  _toggle = type => {
    this.setState({
      [type]: !this.state[type]
    });
  };
  _toggleCensusFormExplanation = () => {
    this.setState({
      showExplanation: !this.state.showExplanation,
      currentEmployee: null,
      showClassAndDivisionDetailsModal: false
    });
  };
  _toggleAddCensusForm = () => {
    this.setState({
      showExplanation: false,
      showDropZone: !this.state.showDropZone
    });
  };
  _toggleShowEmployee = () => {
    this.setState({
      showNewEmployee: !this.state.showNewEmployee,
      currentEmployee: null,
      showClassAndDivisionDetailsModal: false
    });
  };
  _showClassAndDivisionDetailsModal = () => {
    this.setState({
      showClassAndDivisionDetailsModal: !this.state.showClassAndDivisionDetailsModal,
      showNewEmployee: false
    });
  };
  _selectEmployee = employee => {
    this.setState({
      showNewEmployee: true,
      currentEmployee: {
        ...employee
      }
    });
  };
  render() {
    const styles = {
      customMaxWidth: {
        maxWidth: 'unset !important'
      },
      censusExample: {
        marginTop: 20,
        height: 'auto',
        width: '100%',
        cursor: 'pointer',
        boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
        '&:hover': {
          boxShadow: 'none',
          transition: 'all 0.1s ease-out'
        }
      },
      censusExampleLarge: {
        position: 'relative',
        height: 'auto',
        width: '100%',
        zIndex: '9999'
      },
      contentBlockHeight: {
        maxHeight: '1000px'
      },
      btnGroup: {
        marginTop: '20px'
      },
      link: {
        textDecoration: 'none',
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-around',
        margin: '10px',
        padding: '10px',
        backgroundColor: Theme.colors.lightGrey,
        boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
        '&:hover': {
          boxShadow: '0px 1px 1px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px -1px rgba(0, 0, 0, 0.12)',
          filter: 'brightness(97%)'
        }
      },
      logo: {
        display: 'block',
        maxHeight: '50px',
        maxWidth: '100px'
      }
    };
    const templateImage = this.props.currentAccountMeta.isStudentGroup ? censusFormImageStudent : censusFormImage;
    const maritalStatusString = maritalStatusOptions().map(option => `"${option}"`).join(', ');
    let userFields = [{
      name: i18n.t(tokens.labels.firstname)
    }, {
      name: i18n.t(tokens.labels.lastname)
    }, {
      name: i18n.t(tokens.labels.email)
    }, {
      name: i18n.t(tokens.labels.employees.class),
      subtext: i18n.t(tokens.labels.census.mustAlreadyBeCreated)
    }, {
      name: i18n.t(tokens.labels.employees.division),
      subtext: i18n.t(tokens.labels.census.mustAlreadyBeCreated)
    }, {
      name: i18n.t(tokens.labels.birthdate),
      subtext: i18n.t(tokens.labels.census.dateFormat)
    }, {
      name: i18n.t(tokens.labels.gender),
      subtext: i18n.t(tokens.labels.census.genderOptions)
    }, {
      name: i18n.t(tokens.titles.coverage),
      subtext: i18n.t(tokens.labels.census.planOptions)
    }, {
      name: i18n.t(tokens.labels.province),
      subtext: i18n.t(tokens.labels.census.abbreviatedValues)
    }, {
      name: i18n.t(tokens.labels.signup.language),
      subtext: i18n.t(tokens.labels.census.languageInstructions)
    }, {
      name: i18n.t(tokens.labels.waitingPeriod),
      subtext: i18n.t(tokens.labels.census.waitingPeriodInstructions)
    }];
    if (this.props.currentAccountMeta.isStudentGroup) {
      userFields.push({
        name: i18n.t(tokens.labels.employees.studentID)
      });
      userFields.push({
        name: i18n.t(tokens.labels.employees.studyStartDate),
        subtext: i18n.t(tokens.labels.census.dateFormat)
      });
      userFields.push({
        name: i18n.t(tokens.labels.employees.degree)
      });
      userFields.push({
        name: i18n.t(tokens.labels.maritalStatus),
        subtext: `${i18n.t(tokens.labels.census.oneOf).toLowerCase()} ${maritalStatusString}`
      });
      userFields.push({
        name: i18n.t(tokens.labels.phoneNumber),
        subtext: '1112223333'
      });
      userFields.push({
        name: i18n.t(tokens.labels.addressLineOne),
        subtext: '123 Example St'
      });
      userFields.push({
        name: i18n.t(tokens.labels.addressLineTwo),
        subtext: `${i18n.t(tokens.labels.addressLineTwoExample)} (${i18n.t(tokens.titles.optional)})`
      });
      userFields.push({
        name: i18n.t(tokens.labels.city)
      });
      userFields.push({
        name: i18n.t(tokens.labels.postalCode),
        subtext: 'A1B 2C3'
      });
    } else {
      userFields.push({
        name: i18n.t(tokens.labels.employees.hireDate),
        subtext: i18n.t(tokens.labels.census.dateFormat)
      });
      userFields.push({
        name: i18n.t(tokens.labels.employees.occupation)
      });
      userFields.push({
        name: i18n.t(tokens.labels.employees.earningsType),
        subtext: i18n.t(tokens.labels.census.earningsTypeOptions)
      });
      userFields.push({
        name: i18n.t(tokens.labels.employees.salary),
        subtext: i18n.t(tokens.labels.census.salaryRequirement)
      });
      userFields.push({
        name: i18n.t(tokens.labels.employees.hoursPerWeek),
        subtext: i18n.t(tokens.labels.census.hourlyRequirement)
      });
      userFields.push({
        name: i18n.t(tokens.labels.employees.hourlyWage),
        subtext: i18n.t(tokens.labels.census.hourlyRequirement)
      });
      userFields.push({
        name: i18n.t(tokens.labels.employees.payrollID)
      });
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.props.currentAccountMeta.status === 3 && this.props.currentAccountMeta.state <= 4 || this.props.currentAccountMeta.status === 0 && this.props.currentAccountMeta.state === 0 ? /*#__PURE__*/React.createElement(MessageCard, {
      title: i18n.t(tokens.labels.census.censusData),
      subtitle: i18n.t(tokens.labels.census.youCanAddMembersByBulkCsvUpload),
      btn: true,
      btnName: i18n.t(tokens.buttons.submitCensus),
      btnOnClick: this._submitCensus,
      btn2: true,
      btnName2: i18n.t(tokens.buttons.addCensusSheet),
      btnOnClick2: this._toggleCensusFormExplanation
    }) : /*#__PURE__*/React.createElement(MessageCard, {
      title: i18n.t(tokens.labels.census.censusData),
      subtitle: i18n.t(tokens.labels.census.addMembersInstructions),
      btn: true,
      btnName: i18n.t(tokens.buttons.addCensusSheet),
      btnOnClick: this._toggleCensusFormExplanation
    }), this.state.showNewEmployee && /*#__PURE__*/React.createElement(EmployeeModalHandler, {
      open: this.state.showNewEmployee,
      close: this._toggleShowEmployee,
      isEdit: Boolean(this.state.currentEmployee),
      currentEmployee: this.state.currentEmployee,
      isMasterSite: this.props.isMasterSite,
      addUser: this.props.addUser,
      classData: this.props.classData,
      divisions: this.props.divisions,
      currentAccountMeta: this.props.currentAccountMeta,
      showTerminateMemberButton: Boolean(this.state.currentEmployee),
      removeUser: this.props.removeUser,
      updateUser: this.props.updateUser
    }), this.state.showClassAndDivisionDetailsModal && /*#__PURE__*/React.createElement(ClassAndDivisionDetailsModal, {
      divisions: this.props.divisions,
      classesData: this.props.classData,
      showModal: this.state.showClassAndDivisionDetailsModal,
      hideModal: this._showClassAndDivisionDetailsModal
    }), this.state.largePhoto ? /*#__PURE__*/React.createElement(Modal, {
      large: true,
      open: this.state.largePhoto,
      onClose: () => this._toggle('largePhoto'),
      title: i18n.t(tokens.labels.census.requiredColumnsForCensusForm)
    }, /*#__PURE__*/React.createElement("img", {
      onClick: () => this._toggle('largePhoto'),
      alt: "Example Census Document Large",
      src: templateImage,
      style: styles.censusExampleLarge
    })) : /*#__PURE__*/React.createElement(Modal, {
      open: this.state.showExplanation,
      onClose: this._toggleCensusFormExplanation,
      title: i18n.t(tokens.labels.census.uploadCensusForm),
      primaryButton: {
        label: i18n.t(tokens.buttons.continue),
        onClick: this._toggleAddCensusForm
      },
      loader: this.props.loader
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true,
      light: true,
      customStyle: {
        height: "45.75px"
      }
    }, i18n.t(tokens.labels.census.youMustProvideASheet)), userFields.map(field => /*#__PURE__*/React.createElement("div", {
      key: field.name,
      style: {
        marginTop: 5,
        height: field.name === i18n.t(tokens.labels.maritalStatus) ? '50px' : "20.52px"
      }
    }, /*#__PURE__*/React.createElement(Text, {
      small: true,
      bold: true,
      display: "inline"
    }, "\u25CF ", field.name), field.subtext && /*#__PURE__*/React.createElement(Text, {
      key: field.subtext,
      tiny: true,
      display: "inline"
    }, "\xA0-\xA0", field.subtext))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      sx: {
        ...styles.btnGroup,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center"
      }
    }, this.state.showTemplateModal ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      medium: true,
      bold: true
    }, i18n.t(tokens.labels.census.chooseTemplateFileType)), /*#__PURE__*/React.createElement(StyledLink, {
      href: this.props.currentAccountMeta.isStudentGroup ? "https://d6hvupc5g7lnm.cloudfront.net/files/census-form-student.csv" : "https://d6hvupc5g7lnm.cloudfront.net/files/census-form.csv",
      download: "census-form.csv"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "File type icon",
      src: csvIcon,
      style: styles.logo
    }), /*#__PURE__*/React.createElement(Text, {
      mediumLarge: true,
      bold: true,
      customStyle: {
        textAlign: 'right'
      }
    }, ".csv")), /*#__PURE__*/React.createElement(StyledLink, {
      href: this.props.currentAccountMeta.isStudentGroup ? "https://d6hvupc5g7lnm.cloudfront.net/files/census-form-student.xlsx" : "https://d6hvupc5g7lnm.cloudfront.net/files/census-form.xlsx",
      download: "census-form.xlsx"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "File type icon",
      src: xlsIcon,
      style: styles.logo
    }), /*#__PURE__*/React.createElement(Text, {
      mediumLarge: true,
      bold: true,
      customStyle: {
        textAlign: 'right'
      }
    }, ".xlsx")), /*#__PURE__*/React.createElement(StyledLink, {
      href: this.props.currentAccountMeta.isStudentGroup ? "https://d6hvupc5g7lnm.cloudfront.net/files/census-form-student.numbers" : "https://d6hvupc5g7lnm.cloudfront.net/files/census-form.numbers",
      download: "census-form.numbers"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "File type icon",
      src: numbersIcon,
      style: styles.logo
    }), /*#__PURE__*/React.createElement(Text, {
      mediumLarge: true,
      bold: true,
      customStyle: {
        textAlign: 'right'
      }
    }, ".numbers"))) : /*#__PURE__*/React.createElement(Button, {
      onClick: () => this._toggle('showTemplateModal'),
      transparent: true
    }, i18n.t(tokens.buttons.downloadBlankTemplate)), /*#__PURE__*/React.createElement(Text, {
      marginTop: "10px",
      medium: true,
      light: true
    }, i18n.t(tokens.labels.census.viewTemplate))), /*#__PURE__*/React.createElement("img", {
      onClick: () => this._toggle('largePhoto'),
      alt: "Example Census Document",
      title: i18n.t(tokens.labels.census.viewDocumentExpanded),
      src: templateImage,
      style: styles.censusExample
    })), this.state.showDropZone && /*#__PURE__*/React.createElement(FileDropZoneModal, {
      title: i18n.t(tokens.labels.census.selectCsvFiles),
      hideModal: this._toggleAddCensusForm,
      showModal: this.state.showDropZone,
      maxItems: 1,
      type: "Census Form",
      submitFile: this._submitFile,
      acceptedFiles: "text/csv, .csv",
      loader: this.props.loader
    }), /*#__PURE__*/React.createElement(ContentBlock, {
      style: styles.contentBlockHeight
    }, /*#__PURE__*/React.createElement(Text, {
      mediumLarge: true,
      bold: true,
      display: "block",
      align: "left",
      margin: "20px 0",
      customLinkStyle: {
        lineHeight: '40px'
      }
    }, i18n.t(tokens.labels.census.censusData)), this.state.failedRecords && /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: 20
      }
    }, /*#__PURE__*/React.createElement(Text, {
      bold: true,
      color: "red",
      margin: "0 0 10px 0"
    }, "The census file upload failed due to the below file errors. Please correct the records and re-upload the census file."), Object.keys(this.state.failedRecords).map(index => {
      const record = this.state.failedRecords[index];
      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 10
        },
        key: record.row["first name"]
      }, /*#__PURE__*/React.createElement(Text, {
        color: "red"
      }, `Record ${index} for ${record.row["first name"]} ${record.row["last name"]} failed for the following reason(s): `), record.failureVerbiages.map(verbiage => /*#__PURE__*/React.createElement(Text, {
        key: verbiage,
        small: true,
        margin: "0 0 0 20px"
      }, "\u2022\xA0\xA0", verbiage)));
    })), this.props.currentAccountMeta.status === 3 && /*#__PURE__*/React.createElement(Text, {
      color: "red",
      margin: "0 0 20px 0"
    }, i18n.t(tokens.labels.census.revisionNotice)), this.props.census.length === 0 ? /*#__PURE__*/React.createElement(Text, null, i18n.t(tokens.labels.census.noCensusData)) : /*#__PURE__*/React.createElement(CensusTable, {
      census: this.props.census,
      classData: this.props.classData,
      divisions: this.props.divisions,
      onSelectUser: this._selectEmployee,
      style: {
        fontFamily: 'inherit'
      },
      currentAccountMeta: this.props.currentAccountMeta
    }), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      style: {
        ...styles.btnGroup,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end"
      }
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: this._showClassAndDivisionDetailsModal,
      transparent: true
    }, i18n.t(tokens.buttons["classes & divisions"])), /*#__PURE__*/React.createElement(Button, {
      testid: "add-employee",
      transparent: true,
      onClick: this._toggleShowEmployee
    }, /*#__PURE__*/React.createElement(AddIcon, {
      style: {
        lineHeight: '21px',
        color: 'inherit'
      }
    }), "\xA0", i18n.t(tokens.labels.employees.member)))), /*#__PURE__*/React.createElement(StepCompletionNotif, {
      dialog: i18n.t(tokens.labels.census.successfulSubmission),
      type: "Census",
      open: this.state.successDialogOpen,
      handleClose: this._closeSuccessDialog,
      handleNext: this._goToNextStep,
      disableBackdropClick: true,
      disableEscapeKeyDown: true,
      maxWidth: "550px"
    }), /*#__PURE__*/React.createElement("span", {
      id: "census-data"
    }));
  }
}
export default Census;